<template>
    <div v-if="value.meta">
      <!-- ... other form sections ... -->

    <el-divider>Required Documents</el-divider>
    <el-row :gutter="60">
      <el-col :span="24">
        <el-form-item
          class="full"
          prop="meta.proofOfAgeFiles"
          label="Proof of Age"
          :rules="{
            required: true,
            validator: validateProofOfAge,
            trigger: 'change'
        }"
        >
          <span class="mt-3 fs-11px gray-text">
            <el-tooltip placement="top">
              <template #content>
                Please upload a picture of an ID which shows member's Date of Birth.
              </template>
              <i class="el-icon-info"></i>
            </el-tooltip>
            Please upload a picture of an ID which shows member’s Date of Birth.
          </span>
          <el-upload
            :action="fileUpdateUrl"
            :headers="uploadHeaders"
            :accept="accept"
            :on-remove="handleRemove"
            :before-upload="(file) => beforeUpload(file)"
            :limit="1"
            :on-preview="openFilePreview"
            :on-exceed="handleExceed"
            :on-success="(res, file, fileList) => onSuccess(res, file, fileList)"
            :file-list="fileList">
            <el-button size="small" type="secondary">Click to upload</el-button>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>

    <el-divider>Ethnicity Information</el-divider>
    <el-row :gutter="60">
      <el-col :span="24" :md="12">
        <el-form-item
          prop="meta.ethnicity"
          label="Your Ethnicity"
          required
        >
          <el-select
            class="mt-05"
            v-model="value.meta.ethnicity"
            placeholder="Select your ethnicity"
          >
            <el-option
              v-for="item in primaryEthnicityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="value.meta.ethnicity === 'other'"
            v-model="value.meta.ethnicityOther"
            class="mt-2"
            placeholder="Please specify your ethnicity"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24" :md="12">
        <el-form-item
          prop="meta.ethnicityDetail"
          label="If you would like, please tell us more about your ethnicity"
        >
          <el-select
            class="mt-05"
            v-model="value.meta.ethnicityDetail"
            multiple
            placeholder="Select additional ethnicity details"
            @change="handleEthnicityDetailChange"
          >
            <el-option-group
              v-for="group in ethnicityDetailOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
          <el-input
            v-if="showEthnicityDetailOther"
            v-model="value.meta.ethnicityDetailOther"
            class="mt-2"
            placeholder="Please specify additional ethnicity details"
          />
        </el-form-item>
      </el-col>
    </el-row>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex';
import { fileUploadAccepts } from '@/utils/constants';
import _ from 'lodash';
import playerDetails from '@/mixins/player-details';

export default {
  name: 'ClientExtras',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      fileList: [],
      accept: fileUploadAccepts,
      primaryEthnicityOptions: [
        { value: 'maori', label: 'Māori' },
        { value: 'pacific', label: 'Pacific Peoples' },
        { value: 'asian', label: 'Asian' },
        { value: 'indian', label: 'Indian' },
        { value: 'european', label: 'European' },
        { value: 'other', label: 'Other' }
      ],
      ethnicityDetailOptions: [
        {
          label: 'Māori',
          options: [
            { value: 'maori', label: 'Tangata Whenua/Māori' },
            { value: 'pakeha', label: 'Pākehā/NZ European' }
          ]
        },
        {
          label: 'Pacific Peoples',
          options: [
            { value: 'cook_islands', label: 'Cook Islands' },
            { value: 'fiji', label: 'Fiji' },
            { value: 'niue', label: 'Niue' },
            { value: 'samoa', label: 'Samoa' },
            { value: 'tokelau', label: 'Tokelau' },
            { value: 'tonga', label: 'Tonga' },
            { value: 'tuvalu', label: 'Tuvalu' },
            { value: 'pacific_other', label: 'Other' }
          ]
        },
        {
          label: 'Asian',
          options: [
            { value: 'china', label: 'China' },
            { value: 'india', label: 'India' },
            { value: 'japan', label: 'Japan' },
            { value: 'korea', label: 'Korea' },
            { value: 'malaysia', label: 'Malaysia' },
            { value: 'philippines', label: 'The Philippines' },
            { value: 'sri_lanka', label: 'Sri Lanka' },
            { value: 'taiwan', label: 'Taiwan' },
            { value: 'thailand', label: 'Thailand' },
            { value: 'asian_other', label: 'Other' }
          ]
        },
        {
          label: 'Other European Heritage',
          options: [
            { value: 'australia', label: 'Australia' },
            { value: 'britain_ireland', label: 'Britain & Ireland' },
            { value: 'north_america', label: 'North America' },
            { value: 'south_africa', label: 'South Africa' },
            { value: 'european_other', label: 'Other' }
          ]
        },
        {
          label: 'MELAA or other',
          options: [
            { value: 'african', label: 'African' },
            { value: 'latin_american', label: 'Latin American' },
            { value: 'middle_eastern', label: 'Middle Eastern' },
            { value: 'melaa_other', label: 'Other' }
          ]
        }
      ],
    };
  },
  mounted() {
    this.fileList = _.get(this.value, 'meta.proofOfAgeFiles', []);
  },
  computed: {
    fileUpdateUrl() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/attachments`;
    },
    showEthnicityDetailOther() {
      const otherValues = ['pacific_other', 'asian_other', 'european_other', 'melaa_other'];
      return this.value.meta.ethnicityDetail?.some((value) => otherValues.includes(value));
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
  methods: {
    validateProofOfAge(rule, value, callback) {
      if (!this.value.meta.proofOfAgeFiles || this.value.meta.proofOfAgeFiles.length === 0) {
        callback(new Error('Proof of age document is required'));
      } else {
        callback();
      }
    },
    handleEthnicityDetailChange() {
      // Reset the "other" text input if no "other" options are selected
      if (!this.showEthnicityDetailOther) {
        this.value.meta.ethnicityDetailOther = '';
      }
    },
    // File handling methods copied from 8-extras.vue
    async openFilePreview(file) {
      const fileRes = await this.$http.get('/assemble/api/v1/portal/files/signed-url', {
        params: {
          fileName: file.name,
        },
      });
      const { url } = fileRes.data;
      window.open(url);
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => item.name !== file.name);
      this.value.meta.proofOfAgeFiles = this.value.meta.proofOfAgeFiles.filter((item) => item.name !== file.name);
      this.$emit('input', this.value);
    },
    handleExceed(files) {
      this.$message.warning(`The limit is 1, you selected ${files.length} files this time`);
    },
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    onSuccess(res) {
      if (this.value.meta.proofOfAgeFiles) {
        this.value.meta.proofOfAgeFiles.push({
          name: res.name,
          url: res.s3Path
        });
      } else {
        this.value.meta.proofOfAgeFiles = [{
          name: res.name,
          url: res.s3Path
        }];
      }
      this.$emit('input', this.value);
    },
  }
};
</script>

  <style lang="scss" scoped>
  .el-select {
    width: 100%;
  }
  </style>
